/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import * as React from 'react';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';
import NavMenu from './NavMenu';
import { connect } from 'react-redux';

interface Props {
  children?: React.ReactNode;
  isMenuExpanded?: boolean;
}

class Layout extends React.Component<Props, {}>{
    render() {
    const sidebarWidth = this.props.isMenuExpanded ? 250 : 70;
    return (
        <React.Fragment>
          <NavMenu />
          <Toolbar />
          <Container
            maxWidth={false}
            sx={{
              // Shift content when the sidebar is expanded so it doesn't overlay
              marginLeft: `${sidebarWidth}px`,
              width: 'auto',   // important
              marginTop: '40px',
              paddingLeft: '24px',
              paddingRight: '24px',
              backgroundColor: '#f1f3f5',
              minHeight: 'calc(100vh - 64px)',
                transition: 'margin-left 225ms cubic-bezier(0.4, 0, 0.2, 1)'
            }}
          >
            {this.props.children}
          </Container>
        </React.Fragment>
      );
  }
}
const mapStateToProps = (state: any) => ({
  isMenuExpanded: state.navMenu?.isMenuExpanded
});

export default connect(mapStateToProps)(Layout);
